export const CouponTypes = {
    GIFT_CARD: 1,
    PROMOTIONAL: 2,
    CORPORATE: 4,
};
